// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Input from "../../components/html/Input.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../models/Kkm.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__Colors from "../../../../../packages/components/src/Colors.js";
import * as Buhta_components__CopyButton from "../../../../../packages/components/src/CopyButton.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__TopLoadingBar from "../../../../../packages/components/src/atoms/TopLoadingBar.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmsPage$Item(Props) {
  let org = Props.org;
  let kkm = Props.kkm;
  let onDelete = Props.onDelete;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = React.useState(function () {
    return false;
  });
  const setIsHovered = match$1[1];
  const match$2 = kkm.state;
  let route;
  switch (match$2) {
    case "initial" :
      route = kkm.ofd_provider_id === 1 ? contextRoute({
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: kkm.id,
              _1: /* Register */ 1
            }
          }
        }) : contextRoute({
          TAG: /* Kassa */ 2,
          _0: {
            TAG: /* Kkms */ 0,
            _0: {
              TAG: /* Kkm */ 0,
              _0: kkm.id,
              _1: /* Start */ 0
            }
          }
        });
      break;
    case "pending" :
      route = contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: {
            TAG: /* Kkm */ 0,
            _0: kkm.id,
            _1: /* Link */ 2
          }
        }
      });
      break;
    case "registering" :
      route = contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: /* List */ 1
        }
      });
      break;
    default:
      route = contextRoute({
        TAG: /* Kassa */ 2,
        _0: {
          TAG: /* Kkms */ 0,
          _0: {
            TAG: /* Kkm */ 0,
            _0: kkm.id,
            _1: /* View */ 3
          }
        }
      });
  }
  const match$3 = kkm.state;
  let tmp;
  switch (match$3) {
    case "initial" :
      tmp = JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx("img", {
          className: "w-6 h-6",
          src: StaticAsset.src("/static/icons/delete-red.svg")
        }),
        className: "hover:bg-gray-pale p-1",
        onClick: (function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          Curry._1(onDelete, kkm.id);
        })
      });
      break;
    case "pending" :
    case "registering" :
    case "unlinked" :
    case "unlinking" :
      tmp = null;
      break;
    default:
      tmp = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("button", {
          children: match$1[0] ? JsxRuntime.jsx("img", {
              className: "w-6 h-6",
              src: StaticAsset.src("/static/icons/settings-black-24.svg")
            }) : JsxRuntime.jsx("img", {
              className: "w-6 h-6",
              src: StaticAsset.src("/static/icons/settings-24.svg")
            }),
          className: "hover:bg-gray-light rounded",
          onClick: (function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            Buhta_cabinet__Route.navigateTo(contextRoute({
              TAG: /* Kassa */ 2,
              _0: {
                TAG: /* Kkms */ 0,
                _0: {
                  TAG: /* Kkm */ 0,
                  _0: kkm.id,
                  _1: {
                    TAG: /* Settings */ 0,
                    _0: /* General */ 0
                  }
                }
              }
            }));
          })
        }),
        onMouseEnter: (function (param) {
          Curry._1(setIsHovered, (function (param) {
            return true;
          }));
        }),
        onMouseLeave: (function (param) {
          Curry._1(setIsHovered, (function (param) {
            return false;
          }));
        })
      });
  }
  const match$4 = kkm.state;
  let tmp$1;
  let exit = 0;
  switch (match$4) {
    case "initial" :
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: "text-white",
          children: "Новая"
        }),
        className: "bg-alert rounded-sm py-0.5 px-2 inline-block"
      });
      break;
    case "pending" :
    case "registering" :
      exit = 1;
      break;
    case "unlinked" :
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: "text-white",
          children: "Снята с учета"
        }),
        className: "bg-default-gray rounded-sm py-0.5 px-2 inline-block"
      });
      break;
    case "unlinking" :
      tmp$1 = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: "Снимается с учета"
        }),
        className: "bg-warning rounded-sm py-0.5 px-2 inline-block"
      });
      break;
    default:
      const shift_id = String(kkm.shift_id);
      tmp$1 = kkm.shift_opened ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-white",
            children: "Смена №" + shift_id
          }),
          className: "bg-success rounded-sm py-0.5 px-2 inline-block"
        }) : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-white",
            children: "Смена №" + shift_id + " - Закрыта"
          }),
          className: "bg-default-gray rounded-sm py-0.5 px-2 inline-block"
        });
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        children: "На регистрации"
      }),
      className: "bg-warning rounded-sm py-0.5 px-2 inline-block"
    });
  }
  const match$5 = kkm.state;
  let tmp$2;
  let exit$1 = 0;
  switch (match$5) {
    case "initial" :
    case "pending" :
    case "registering" :
    case "unlinked" :
    case "unlinking" :
      exit$1 = 1;
      break;
    default:
      tmp$2 = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
        className: "text-success",
        children: "Подключено"
      });
  }
  if (exit$1 === 1) {
    tmp$2 = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
      className: "text-alert",
      children: "Отключено"
    });
  }
  const match$6 = kkm.state;
  let tmp$3;
  switch (match$6) {
    case "initial" :
      tmp$3 = JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
        title: "Зарегистрировать",
        route: route,
        onClick: (function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          Buhta_cabinet__Route.navigateTo(route);
        }),
        link: false,
        className: "w-full mt-6 py-3"
      });
      break;
    case "pending" :
      tmp$3 = JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
        title: "Соединить с ОФД",
        onClick: (function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          Buhta_cabinet__Route.navigateTo(route);
        }),
        link: false,
        className: "w-full mt-6 py-3"
      });
      break;
    case "registering" :
      tmp$3 = null;
      break;
    default:
      tmp$3 = JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
        title: "Перейти в ККМ",
        color: /* White */ 0,
        onClick: (function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          Buhta_cabinet__Route.navigateTo(route);
        }),
        link: false,
        className: "w-full mt-6 py-3"
      });
  }
  return JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
    route: route,
    className: "border border-gray-main rounded-md p-6 w-91.5 shadow-kkms hover:shadow-kkm-hover bg-white last:mb-30 lg:last:mb-0",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
            className: "w-72 truncate",
            children: kkm.name
          }),
          tmp
        ],
        className: "flex justify-between items-center"
      }),
      JsxRuntime.jsx("div", {
        children: tmp$1,
        className: "flex gap-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-gray-medium",
            children: "Серийный номер"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: kkm.serial_num
              }),
              JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                text: kkm.serial_num
              })
            ],
            className: "flex items-center"
          })
        ],
        className: "flex justify-between mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-gray-medium",
            children: "Рег. номер"
          }),
          kkm.ofd_register_num !== "" ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  children: kkm.ofd_register_num
                }),
                JsxRuntime.jsx(Buhta_components__CopyButton.make, {
                  text: kkm.ofd_register_num
                })
              ],
              className: "flex items-center"
            }) : null
        ],
        className: "flex justify-between mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-gray-medium",
            children: "Соединение с ОФД"
          }),
          tmp$2
        ],
        className: "flex justify-between mt-2"
      }),
      tmp$3
    ]
  });
}

const Item = {
  make: KkmsPage$Item
};

function KkmsPage(Props) {
  let org = Props.org;
  let openMenu = Props.openMenu;
  const jitsu = JitsuReact.useJitsu();
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const match$2 = React.useState(function () {
    return "";
  });
  const setSearchText = match$2[1];
  const searchText = match$2[0];
  const match$3 = React.useState(function () {
    return 1;
  });
  const setPage = match$3[1];
  const page = match$3[0];
  const match$4 = React.useState(function () {
    return false;
  });
  const setLastPage = match$4[1];
  const match$5 = React.useState(function () {
    return 1;
  });
  const setNonce = match$5[1];
  const nonce = match$5[0];
  const match$6 = React.useState(function () {
    return /* Complete */ 1;
  });
  const setBarState = match$6[1];
  const match$7 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Kassa.KkmManagerService.grid, undefined);
  const dispatch = match$7[1];
  const grid = match$7[0];
  const match$8 = Buhta_cabinet__Kkm.KkmsCtx.use(undefined);
  const dispatchKkms = match$8[1];
  React.useEffect((function () {
    const params_search = searchText === "" ? undefined : Stdlib__String.trim(searchText);
    const params = {
      search: params_search,
      page: page,
      filters: /* [] */ 0,
      expand: /* [] */ 0
    };
    if (!(searchText.length > 1 || searchText.length === 0)) {
      return;
    }
    const debounce = setTimeout((function (param) {
      Curry._3(dispatch, undefined, params, undefined);
    }), 200);
    return (function (param) {
      clearTimeout(debounce);
    });
  }), [
    searchText,
    page,
    nonce
  ]);
  React.useEffect((function () {
    if (grid === "Loading") {
      Curry._1(setBarState, (function (param) {
        return /* Start */ 0;
      }));
    } else {
      Curry._1(setBarState, (function (param) {
        return /* Complete */ 1;
      }));
    }
    if (typeof grid !== "string" && grid.NAME === "Data") {
      const data = grid.VAL;
      Curry._1(dispatchKkms, page === 1 ? ({
          TAG: /* Replace */ 1,
          _0: data
        }) : ({
          TAG: /* Add */ 0,
          _0: data
        }));
      Curry._1(setLastPage, (function (param) {
        return Stdlib__List.length(data) < 25;
      }));
    }
    
  }), [grid]);
  const onDelete = function (id) {
    const __x = Buhta_cabinet__Kassa.KkmManagerService.$$delete(tenant, id, undefined);
    $$Promise.get(__x, (function (result) {
      if (result.TAG !== /* Ok */ 0) {
        return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при удалении кассы");
      }
      Curry._1(setNonce, (function (param) {
        return -nonce | 0;
      }));
      Curry._1(dispatchToasts, {
        TAG: /* Add */ 0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: "ККМ удалена",
          kind: "success",
          onClick: (function (param) {
            
          })
        }
      });
    }));
  };
  const icon = JsxRuntime.jsx("img", {
    className: "w-6 h-6",
    src: StaticAsset.src("/static/icons/cashbox-white-24.svg")
  });
  const newKkmButton = JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Kassa */ 2,
      _0: {
        TAG: /* Kkms */ 0,
        _0: /* Create */ 0
      }
    }),
    className: "bg-links flex rounded-sm px-3 py-2 hover:bg-links-hover active:bg-links-active",
    onLinkClicked: (function (param) {
      Curry._1(jitsu.analytics.track, "kassa.kkms.add_kassa");
    }),
    children: [
      JsxRuntime.jsx("img", {
        className: "w-4 h-4",
        src: StaticAsset.src("/static/icons/plus.svg")
      }),
      JsxRuntime.jsx(Buhta_components__Text.H6.make, {
        className: "ml-1 text-white",
        children: "Новая касса"
      })
    ]
  });
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: "Касса",
      leftChildren: icon,
      openMenu: openMenu,
      rightChildren: newKkmButton
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: "Все кассы",
      rightChildren: newKkmButton
    });
  const dummyCard = JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            className: "w-40 h-6 bg-gray-pale rounded"
          }),
          JsxRuntime.jsx("div", {
            className: "w-6 h-6 bg-gray-pale rounded-3xl"
          })
        ],
        className: "flex justify-between"
      }),
      JsxRuntime.jsx("div", {
        className: "w-30 h-6 bg-gray-pale rounded-sm mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            className: "w-30 h-5 bg-gray-pale rounded-sm shrink-0"
          }),
          JsxRuntime.jsx("div", {
            className: "w-full h-5 bg-gray-pale rounded-sm ml-10"
          })
        ],
        className: "flex mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            className: "w-24 h-5 bg-gray-pale rounded-sm shrink-0"
          }),
          JsxRuntime.jsx("div", {
            className: "w-full h-5 bg-gray-pale rounded-sm ml-20"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            className: "w-30 h-5 bg-gray-pale rounded"
          }),
          JsxRuntime.jsx("div", {
            className: "w-24 h-5 bg-gray-pale rounded"
          })
        ],
        className: "flex justify-between mt-2"
      }),
      JsxRuntime.jsx("div", {
        className: "w-full h-12 bg-gray-pale rounded-sm mt-6"
      })
    ],
    className: "border border-gray-main rounded-md p-6 w-91.5 shadow-kkms bg-white"
  });
  return JsxRuntime.jsxs(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-5 h-5 ",
            alt: "search",
            src: StaticAsset.src("/static/icons/search.svg")
          }),
          JsxRuntime.jsx(Buhta_cabinet__Input.make, {
            className: "sm:text-base h-12",
            value: searchText,
            placeholder: "Поиск...",
            onChange: (function (value) {
              Curry._1(setPage, (function (param) {
                return 1;
              }));
              Curry._1(setSearchText, (function (param) {
                return value;
              }));
            })
          })
        ],
        className: "flex items-center pl-6 w-full bg-white gap-1 border-gray-main border-b"
      }),
      JsxRuntime.jsx(Buhta_components__TopLoadingBar.make, {
        color: Buhta_components__Colors.links,
        height: 3,
        state: match$6[0]
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, kkm) {
                const Key = String(i);
                return JsxRuntime.jsx(KkmsPage$Item, {
                  org: org,
                  kkm: kkm,
                  onDelete: onDelete
                }, Key);
              }), match$8[0])),
              typeof grid === "string" ? (
                  grid === "Loading" ? JsxRuntime.jsxs(React.Fragment, {
                      children: [
                        dummyCard,
                        dummyCard,
                        dummyCard,
                        dummyCard,
                        dummyCard,
                        dummyCard
                      ]
                    }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                ) : (
                  grid.NAME === "Data" ? null : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                )
            ],
            className: "px-4 lg:px-6 py-6 flex w-full flex-wrap gap-6"
          }),
          typeof grid === "string" || !(grid.NAME === "Data" && !match$4[0]) ? null : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                  children: "Загрузить еще"
                }),
                className: "w-full border border-gray-main rounded-sm py-3",
                onClick: (function (param) {
                  Curry._1(setPage, (function (param) {
                    return page + 1 | 0;
                  }));
                })
              }),
              className: "p-6"
            })
        ],
        className: "w-full"
      })
    ],
    className: "flex-col bg-gray-pale"
  });
}

const timeout = 3000;

const make = KkmsPage;

export {
  timeout,
  Item,
  make,
}
/* @jitsu/jitsu-react Not a pure module */
